(function () {
  'use strict';
  if (window.dbStorefrontTracking) return;
  var layer = window.dataLayer = window.dataLayer || [];
  var started = false;
  var consent = false;
  var sent = {};
  var pendingKey = 'db-tracking-pending-form';
  function command() { layer.push(arguments); }
  command('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied'
  });
  function safePath(value) {
    try {
      var url = new URL(value, window.location.origin);
      var path = decodeURIComponent(url.pathname);
      if (/@|[\w.+-]+%40/i.test(path) || /\/(checkouts?|account|customer_authentication|orders)(\/|$)/i.test(path)) return '/';
      return url.origin + url.pathname;
    } catch (_) { return ''; }
  }
  function publicText(value) {
    return String(value || '').replace(/\s+/g, ' ').replace(/[^\s@]+@[^\s@]+/g, '[redacted]').slice(0, 100);
  }
  function emit(name, properties) {
    if (!consent) return;
    var allowed = ['cta_click', 'marketplace_click', 'social_link_click', 'contact_link_click', 'faq_click', 'email_subscribe', 'contact_form_submission'];
    if (allowed.indexOf(name) < 0) return;
    var data = { event: 'db_storefront_event', db_event_name: name,
      db_page_location: safePath(window.location.href), db_link_url: '', db_link_domain: '',
      db_link_text: '', db_form_id: '', db_faq_question: '', db_contact_method: '' };
    var keys = ['link_url', 'link_domain', 'link_text', 'form_id', 'faq_question', 'contact_method'];
    keys.forEach(function (key) {
      if (properties && properties[key]) data['db_' + key] = publicText(properties[key]);
    });
    layer.push(data);
  }
  function completeForm(kind, source, token) {
    var id = kind + ':' + source + ':' + token;
    if (sent[id]) return;
    sent[id] = true;
    emit(kind, { form_id: source });
  }
  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    consent = !!(privacy && privacy.analyticsProcessingAllowed());
    var marketing = !!(privacy && privacy.marketingAllowed() && privacy.saleOfDataAllowed());
    command('consent', 'update', {
      analytics_storage: consent ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied'
    });
    if (consent && !started) {
      started = true;
      layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KRN9GBF';
      document.head.appendChild(script);
    }
  }
  function remember(form) {
    if (!consent) return;
    var isNewsletter = !!form.querySelector('[name="contact[tags]"][value*="newsletter"]');
    var isContact = !!form.querySelector('[name="form_type"][value="contact"]');
    if (!isNewsletter && !isContact) return;
    var source = isNewsletter ? 'shopify_newsletter' : 'shopify_contact';
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ kind: isNewsletter ? 'email_subscribe' : 'contact_form_submission', source: source, time: Date.now() })); } catch (_) {}
  }
  function checkSuccess() {
    if (!consent) return;
    var success = document.querySelector('form [data-db-form-success], form .form-success, form .newsletter-form__message--success, form .contact__message--success');
    if (!success || (!success.hasAttribute('data-db-form-success') && !success.getClientRects().length)) return;
    try {
      var pending = JSON.parse(sessionStorage.getItem(pendingKey));
      if (!pending || Date.now() - pending.time > 600000) return;
      var form = success.closest('form');
      var kind = form.querySelector('[name="contact[tags]"][value*="newsletter"]') ? 'email_subscribe' : 'contact_form_submission';
      if (kind !== pending.kind) return;
      sessionStorage.removeItem(pendingKey);
      completeForm(kind, pending.source, pending.time);
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', function () { syncConsent(); checkSuccess(); });
  document.addEventListener('click', function (event) {
    if (!consent || !(event.target instanceof Element)) return;
    var summary = event.target.closest('.db-home-faq summary, .db-faq summary');
    if (summary && !summary.parentElement.open) emit('faq_click', { faq_question: summary.textContent });
    var link = event.target.closest('a[href]');
    if (!link) return;
    var raw = link.getAttribute('href');
    if (/^(mailto:|tel:)/i.test(raw)) { emit('contact_link_click', { contact_method: raw.indexOf('mailto:') === 0 ? 'email' : 'phone' }); return; }
    var url;
    try { url = new URL(raw, window.location.origin); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol)) return;
    var host = url.hostname.replace(/^www\./, '');
    var data = { link_domain: host, link_url: safePath(url.href), link_text: link.textContent };
    if (/(^|\.)(amazon\.[a-z.]+|amzn\.to|walmart\.com|ebay\.[a-z.]+)$/.test(host)) emit('marketplace_click', data);
    else if (/(^|\.)(facebook\.com|instagram\.com|pinterest\.com|tiktok\.com|youtube\.com|youtu\.be|twitter\.com|x\.com)$/.test(host)) emit('social_link_click', data);
    else if (host === window.location.hostname.replace(/^www\./, '') && /shop|buy|discover|read more|our story|free guide|get.*guide/i.test(link.textContent)) emit('cta_click', data);
  });
  document.addEventListener('submit', function (event) { if (event.target instanceof HTMLFormElement) remember(event.target); }, true);
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.type === 'submit' && /^[A-Za-z0-9_-]{1,60}$/.test(String(detail.formId || ''))) completeForm('email_subscribe', 'klaviyo_' + detail.formId, 'page');
  });
  document.addEventListener('db:optin-success', function (event) {
    var source = event.detail && event.detail.funnel;
    if (/^[a-z0-9-]{1,80}$/.test(source || '')) completeForm('email_subscribe', source, 'page');
  });
  window.dbStorefrontTracking = { version: '2026-10-21', syncConsent: syncConsent };
  function ready() {
    syncConsent();
    if (!(window.Shopify && window.Shopify.customerPrivacy) && window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) { syncConsent(); checkSuccess(); } });
    }
    checkSuccess();
    var observer = new MutationObserver(checkSuccess);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
}());
